import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import type { ApiStatusType } from '@tarslib/types/lib/httpApi';
import { ApiStatusTypeMap } from '@tarslib/types/lib/httpApi';
import { Badge, Tooltip } from 'aui';

export type StatusBadgeProps = {
  status: ApiStatusType;
};

export function StatusBadge(props: StatusBadgeProps) {
  const { status } = props;

  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);
  const apiStatusType = ApiStatusTypeMap[status];

  return (
    <Tooltip title={clientI18n(`api.status.${status}`)} align={{ offset: [0, 5] }}>
      <Badge className="ml-1 opacity-40" color={apiStatusType?.color} size="small" />
    </Tooltip>
  );
}
